<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Categorias - Edição</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'download-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <form-download-category :downloadcategory="downloadcategory" :update="true"></form-download-category>
</span>
</template>

<script>
import FormDownloadCategoryComponent from "./partial/FormDownloadCategoryComponent";

export default {
    name: "AddDownloadCategoryComponent",
    created() {
        this.loadDownloadCategory()
    },
    props: {
        down_c_id: {
            require: true
        }
    },
    data() {
        return {
            downloadcategory: {
                down_c_id: '',
                down_c_nome: '',
                down_c_descricao: '',
                down_c_icone: '',
                down_c_imagem: '',
                down_c_status: false,
            },
            upload: null,
            fileName: 'Selecione uma Imagem',
            preview: null,
            langs: true
        }
    },
    methods: {
        loadDownloadCategory() {
            this.$store.dispatch('loadDownloadCategory', this.down_c_id)
                .then(response => this.downloadcategory = response)
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        formDownloadCategory: FormDownloadCategoryComponent
    }
};
</script>

<style scoped>

</style>
